import React from "react";
import { BoletoContainer, InputWrapper, Label, Input } from "./styles";

const BoletoInput = ({ billingDetails, setBillingDetails }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setBillingDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <BoletoContainer>
            <InputWrapper>
                <Label>Endereço:</Label>
                <Input
                    type="text"
                    name="line1"
                    value={billingDetails.line1}
                    onChange={handleChange}
                    placeholder="Rua e número"
                />
            </InputWrapper>
            <InputWrapper>
                <Label>Cidade:</Label>
                <Input type="text" name="city" value={billingDetails.city} onChange={handleChange} />
            </InputWrapper>
            <InputWrapper>
                <Label>Estado:</Label>
                <Input type="text" name="state" value={billingDetails.state} onChange={handleChange} />
            </InputWrapper>
            <InputWrapper>
                <Label>CEP:</Label>
                <Input type="text" name="postal_code" value={billingDetails.postal_code} onChange={handleChange} />
            </InputWrapper>
            <InputWrapper>
                <Label>CPF:</Label>
                <Input
                    type="text"
                    name="cpf"
                    value={billingDetails.cpf}
                    onChange={handleChange}
                    placeholder="000.000.000-00"
                />
            </InputWrapper>
        </BoletoContainer>
    );
};

export default BoletoInput;
